function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

var _ref2 = /*#__PURE__*/React.createElement("path", {
  d: "M16.3312 2C13.7612 2 11.3512 3.28 9.91117 5.4L9.78117 5.59C6.91117 9.82 5.61117 14.92 6.10117 20L6.18117 20.8C6.68117 26.01 11.0612 29.98 16.2912 29.98C21.5412 29.98 25.9212 25.99 26.4012 20.76L26.4912 19.83C26.9712 14.71 25.6312 9.58 22.7112 5.35C21.2612 3.26 18.8812 2 16.3312 2Z",
  fill: "#A6704C"
});

var _ref3 = /*#__PURE__*/React.createElement("path", {
  d: "M16.3312 2C13.7612 2 11.3512 3.28 9.91117 5.4L9.78117 5.59C6.91117 9.82 5.61117 14.92 6.10117 20L6.18117 20.8C6.68117 26.01 11.0612 29.98 16.2912 29.98C21.5412 29.98 25.9212 25.99 26.4012 20.76L26.4912 19.83C26.9712 14.71 25.6312 9.58 22.7112 5.35C21.2612 3.26 18.8812 2 16.3312 2Z",
  fill: "url(#paint0_radial_18_33656)"
});

var _ref4 = /*#__PURE__*/React.createElement("path", {
  d: "M16.3312 2C13.7612 2 11.3512 3.28 9.91117 5.4L9.78117 5.59C6.91117 9.82 5.61117 14.92 6.10117 20L6.18117 20.8C6.68117 26.01 11.0612 29.98 16.2912 29.98C21.5412 29.98 25.9212 25.99 26.4012 20.76L26.4912 19.83C26.9712 14.71 25.6312 9.58 22.7112 5.35C21.2612 3.26 18.8812 2 16.3312 2Z",
  fill: "url(#paint1_radial_18_33656)"
});

var _ref5 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("radialGradient", {
  id: "paint0_radial_18_33656",
  cx: 0,
  cy: 0,
  r: 1,
  gradientUnits: "userSpaceOnUse",
  gradientTransform: "translate(22.75 10.375) rotate(89.7077) scale(24.5003 16.2938)"
}, /*#__PURE__*/React.createElement("stop", {
  offset: 0.0918569,
  stopColor: "#FFCA7F"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.561861,
  stopColor: "#E5945B"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.838029,
  stopColor: "#B87241"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 1,
  stopColor: "#9A6240"
})), /*#__PURE__*/React.createElement("radialGradient", {
  id: "paint1_radial_18_33656",
  cx: 0,
  cy: 0,
  r: 1,
  gradientUnits: "userSpaceOnUse",
  gradientTransform: "translate(16.2933 11.25) rotate(97.4311) scale(22.5645 27.4892)"
}, /*#__PURE__*/React.createElement("stop", {
  offset: 0.552533,
  stopColor: "#974668",
  stopOpacity: 0
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.903751,
  stopColor: "#984663"
})));

function SvgEgg(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ref2, _ref3, _ref4, _ref5);
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgEgg);
export default __webpack_public_path__ + "static/media/egg.3694e07d.svg";
export { ForwardRef as ReactComponent };